import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  IconButton,
  InputBase,
  Badge,
  Menu,
  MenuItem,
  Button,
} from "@mui/material";
import { ShoppingCart, AccountCircle, Search } from "@mui/icons-material";

function Navbar() {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="sticky" sx={{ background: "#0F172A" }}>
      <Toolbar sx={{ justifyContent: "space-between" }}>

        {/* 🔹 Logo */}
        <Typography variant="h6" sx={{ fontWeight: "bold", cursor: "pointer" }}>
          EduStore
        </Typography>

        {/* 🔹 Search Bar */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            background: "#1E293B",
            padding: "5px 10px",
            borderRadius: "8px",
            width: "40%",
          }}
        >
          <Search sx={{ color: "#94A3B8" }} />
          <InputBase
            placeholder="Search products..."
            sx={{ ml: 1, color: "#fff", width: "100%" }}
          />
        </Box>

        {/* 🔹 Right Side */}
        <Box display="flex" alignItems="center" gap={2}>

          {/* Categories Dropdown */}
          <Button
            variant="outlined"
            sx={{ color: "#fff", borderColor: "#fff" }}
            onClick={handleMenuOpen}
          >
            Categories
          </Button>

          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
            <MenuItem onClick={handleMenuClose}>Classroom Furniture</MenuItem>
            <MenuItem onClick={handleMenuClose}>IT Equipment</MenuItem>
            <MenuItem onClick={handleMenuClose}>Laboratory Equipment</MenuItem>
            <MenuItem onClick={handleMenuClose}>Sports Gear</MenuItem>
          </Menu>

          {/* Cart */}
          <IconButton color="inherit">
            <Badge badgeContent={2} color="error">
              <ShoppingCart />
            </Badge>
          </IconButton>

          {/* Profile */}
          <IconButton color="inherit">
            <AccountCircle />
          </IconButton>

        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;